import React from 'react';
import { Button, Paper, Typography } from '@material-ui/core';
import { useModal } from '../../components/general/modalContext';
import ExportHeure from './modules/FormExportHeures';

const OgletExportStat = () => {
  const { openModal, closeModal } = useModal();

  const handleExportClick = async (fileName) => {
    openModal("Exporter Extraction Heures", <div><ExportHeure closeModal={closeModal} /></div>);
  };

  return (
    <div>
      <Paper style={{ padding: '25px' }}>
      <Typography style={{ marginBottom: '25px' }}>
        Exporter par événements le nombre d'heures que chaque bénévole a effectuées
      </Typography>
      <Button variant="contained" color="primary" onClick={() => handleExportClick('ExtractionHeures')}>
        Exporter Extraction Heures
      </Button>
      </Paper>
    </div>
  );
};

export default OgletExportStat;
